import React from 'react';
import DepartmentProfilesTable from './DepartmentProfilesTable';
import CreateDepartmentDialog from './CreateDepartmentDialog';
import Button from '@material-ui/core/Button';
import Loading from 'components/pure/utils/Loading';
import 'styles/admin/DepartmentsPage.styl';

export default class DepartmentsPage extends React.PureComponent {
  render() {
    const {wasDepartmentProfilesFetchError, areDepartmentProfilesLoading} =
      this.props.DepartmentStore;

    const isLoading =
      areDepartmentProfilesLoading ||
      this.props.CardProfileStore.isLoading ||
      this.props.FilterWordsProfileStore.isLoading ||
      this.props.ArchivingProfileStore.isLoading;

    const {user} = this.props.AuthStore;
    return (
      <div className="departments-page">
        <h1>Manage Departments</h1>
        <p>
          In Coach, your teams are grouped into departments. Teams within a department share the
          same customization profiles (fields, archiving, scorecards, and keywords).
        </p>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={this.props.DepartmentFormActions.openCreateDialog}>
            New Department
          </Button>
        </div>
        {wasDepartmentProfilesFetchError ? (
          'Error fetching profiles.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <DepartmentProfilesTable
            flags={user.flags}
            updateDepartment={this.props.DepartmentActions.updateDepartment}
            departmentProfiles={this.props.DepartmentStore.departmentProfiles}
            archivingProfiles={this.props.ArchivingProfileStore.archivingProfiles}
            archivingProfilesError={this.props.ArchivingProfileStore.wasError}
            filterWordsProfiles={this.props.FilterWordsProfileStore.filterWordsProfiles}
            filterWordsProfilesError={this.props.FilterWordsProfileStore.wasError}
            cardProfiles={this.props.CardProfileStore.cardProfiles}
            cardProfilesError={this.props.CardProfileStore.wasError}
          />
        )}
        {this.props.DepartmentFormStore.isCreateDialogOpen && (
          <CreateDepartmentDialog
            errors={this.props.DepartmentFormStore.errors}
            touchedFields={this.props.DepartmentFormStore.touchedFields}
            wasSubmitRequested={this.props.DepartmentFormStore.wasSubmitRequested}
            department={this.props.DepartmentFormStore.department}
            isDepartmentSaving={this.props.DepartmentFormStore.isDepartmentSaving}
            {...this.props.DepartmentFormActions}
            {...this.props.DepartmentActions}
          />
        )}
      </div>
    );
  }
}
